import request from "@/utils/request";

export function addToCompareList(data) {
  return request({
    url: "/user/storeGoodsUserCompare/submit",
    method: "post",
    data: data
  });
}

export function deleteFromCompareList(id) {
  return request({
    url: `/user/storeGoodsUserCompare/${id}/delete`,
    method: "post"
  });
}

export function deleteAllFromCompareList() {
  return request({
    url: `/user/storeGoodsUserCompare/deleteAll`,
    method: "post"
  });
}

export function getCompareList(params) {
  return request({
    url: "/user/storeGoodsUserCompare/page",
    method: "get",
    params
  });
}
